import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MovilesSelectComponent } from './moviles-select.component';
import { HeaderModule } from '../header/header.module';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    MovilesSelectComponent,
  ],
  imports: [
    HeaderModule,
    CommonModule,
    SharedModule
  ],
  exports: [
    MovilesSelectComponent
  ]
})
export class MovilesSelectModule { }
